import { Component, OnInit,ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Title }     from '@angular/platform-browser';
import { Router } from '@angular/router';

import { DMCoQuanService } from '../he-thong/dm-co-quan/dm-co-quan.service';
import { DMCoQuan } from '../he-thong/dm-co-quan/dm-co-quan';
import { DMDonViXuLy,SearchDMDonViXuLy } from './dm-don-vi-xu-ly';
import { DMDonViXuLyService } from './dm-don-vi-xu-ly.service';

import { AuthService } from '../services/auth.service';

declare var jQuery:any;
@Component({    
    selector: 'vnpt-dm-don-vi-xu-ly',
    templateUrl: 'dm-don-vi-xu-ly.component.html',
    providers: [DMDonViXuLyService,DMCoQuanService]
})
export class DMDonViXuLyComponent implements OnInit {
    title:string = "Danh mục Đơn vị xử lý";
    listItems:DMDonViXuLy[] = [];       
    listDMCoQuan:DMCoQuan[] = [];
    
    detailItem:DMDonViXuLy;
    deleteItem:DMDonViXuLy;
        
    saveStatusMessage:string="";
    saveStatus:boolean=true;
  
    paging: number = 1;
    totalCount: number = 0;
    totalPages: number = 1;
    total: number;
    page: number;
    keyword: string = "";
    maxSize:number = 10;    
    clickSubmitted:boolean = false;
    searchItems:SearchDMDonViXuLy = new SearchDMDonViXuLy();
    @ViewChild('myForm') myForm;
    

    Save(){
        if(this.myForm.valid==true){
            this.saveStatusMessage ='Xin vui lòng đợi trong giây lát !';
        
            jQuery("#loader").modal();
            
            this.service.Save(this.detailItem)
                .subscribe((resp) => {
                    if (resp.Success){
                        this.GetListFromPagination(this.paging);
                        this.saveStatusMessage = "Lưu thành công!";
                        this.saveStatus = true;
                    }
                    else{
                        this.saveStatusMessage = "Lỗi khi lưu dữ liệu! Xin vui lòng thực hiện lại sau";
                        this.saveStatus = false;
                    }
                },
                (er) => {
                    if (er.status == 401) {
                        this.router.navigate(['./login']);
                    }
                    console.log(er);
                    this.saveStatusMessage = "Lỗi khi lưu dữ liệu! Xin vui lòng thực hiện lại sau";
                    this.saveStatus = false;
                });
            
            jQuery("#addModal").modal('hide');
            jQuery("#loader").modal();    
            //this.Reset();

        }// End if check submit true
        else{
            console.log("chua luu");
        }
        
        
    }
    
    GetListDMCoQuan() {
        this.dmcoquanService.GetList(this.auth.user.IdTinhThanh)
        .subscribe(
        (data) => {
            this.listDMCoQuan = data;
        },
        er => {
            if (er.status == 401) {
                this.router.navigate(['./login']);
            }
        });

    }// GetList

    AnswerDelete(item:DMDonViXuLy){
        this.deleteItem = item;
        jQuery("#modalConfirm").modal();
    }
    Delete(){
   
        this.deleteItem.TrangThai=0;
        
        this.service.Save(this.deleteItem)
            .subscribe((resp) => {
                if (resp.Success){
                    this.GetListFromPagination(this.paging);
                    this.saveStatusMessage = "Xóa thành công!";
                    this.saveStatus = true;
                }
                else{
                    this.saveStatusMessage = "Lỗi khi lưu dữ liệu! Xin vui lòng thực hiện lại sau";
                    this.saveStatus = false;
                }
            },
            (er) => {
                if (er.status == 401) {
                    this.router.navigate(['./login']);
                }
                console.log(er);
                this.saveStatusMessage = "Lỗi khi lưu dữ liệu! Xin vui lòng thực hiện lại sau";
                this.saveStatus = false;
            });

    }

   

    GetItem(item:DMDonViXuLy){

        this.service.GetItem(item.Id)
        .subscribe(
        (data) => {            
            this.detailItem = data[0];            
        },
        er => {
            if (er.status == 401) {
                this.router.navigate(['./login']);
            }
        });
        jQuery("#addModal").modal(); 
    }

   
   
    // Lấy danh sách từ Stored Procedure phân trang
    GetListFromPagination(paging: number) {

        
        this.service.GetListFromPagination(this.auth.user.IdCoQuan,paging,this.maxSize, this.searchItems.keyword)
            .subscribe(
            (data) => {
                this.listItems = data;
                
                if (this.listItems.length !== 0) {
                    // tổng records trong list cấp đơn vị
                    this.paging = paging;
                    this.totalCount = (data[0]).TotalRows;
                    // tính tổng số trang cần phân dựa vào tổng records
                    this.totalPages = Math.ceil(this.totalCount / this.maxSize);
                   
                } else {
                    
                    if (paging > 1) {
                        this.GetListFromPagination(paging - 1);
                    } else {
                        console.log("ko co record");
                        this.totalPages = 0;
                    }
                }

                

            },
            er => {
                if (er.status == 401) {
                    this.router.navigate(['./login']);
                }
            });

    }
    
   
    SearchChange(action:string=''){     
        if(action=='reset'){
            this.searchItems=new SearchDMDonViXuLy;
        }      
        this.GetListFromPagination(1);
    }
    
    Reset(){
        this.detailItem = new DMDonViXuLy({IdCoQuan:this.auth.user.IdCoQuan});
        this.deleteItem= new DMDonViXuLy({IdCoQuan:this.auth.user.IdCoQuan});
        this.clickSubmitted = false;         
        
    }
    btnSubmit(){
        this.clickSubmitted = true;
    }
    createRange(number) {
        let items = [];
        for (var i = 1; i <= number; i++) {
            items.push(i);
        }
        return items;
    }
   
    constructor(
        private service: DMDonViXuLyService,         
        private dmcoquanService:DMCoQuanService,        
        private auth:AuthService,        
        private router: Router,
        private titleService: Title) {            
        this.Reset();
        
    }

    ngOnInit() {
        this.titleService.setTitle(this.title);
        this.GetListFromPagination(1);
        this.GetListDMCoQuan();          
                              
                
    }
}


// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/dm-don-vi-xu-ly/dm-don-vi-xu-ly.component.ts